<template>
  <div class="order-alerts-container">
    <!-- Plate Max Error -->
    <div v-if="showPlateMaxError" class="position-fixed end-0 bg-white border shadow-lg p-3 rounded mb-3 mr-5 d-none d-md-flex align-items-center" style="z-index: 10000; bottom: 13%;">
      <h6 class="mt-2 text-dark"><i class="fa-solid fa-circle-xmark text-danger me-2"></i> Has alcanzado el máximo de platos por mesa</h6>
    </div>
    <div v-if="showPlateMaxError" class="position-fixed top-0 start-0 w-100 h-100 d-md-none d-flex align-items-center justify-content-center" style="background-color: rgba(0, 0, 0, 0.5); z-index: 10000;">
      <div class="bg-white border shadow-lg p-3 rounded w-100 mx-3">
        <h6 class="mt-2 text-center text-dark"><i class="fa-solid fa-circle-xmark text-danger fs-5 mb-2"></i><br/>Has alcanzado el máximo de platos por mesa</h6>
      </div>
    </div>

    <!-- Delivery Error (409) -->
    <div v-if="showDeliveryError" class="position-fixed end-0 bg-white border shadow-lg p-3 rounded mb-3 mr-5 d-none d-md-flex align-items-center" style="z-index: 10000; bottom: 13%;">
      <h6 class="mt-2 text-dark"><i class="fa-solid fa-circle-xmark text-danger me-2"></i> Tu pedido ya ha sido aceptado y no puedes modificarlo</h6>
    </div>
    <div v-if="showDeliveryError" class="position-fixed top-0 start-0 w-100 h-100 d-md-none d-flex align-items-center justify-content-center" style="background-color: rgba(0, 0, 0, 0.5); z-index: 10000;">
      <div class="bg-white border shadow-lg p-3 rounded w-100 mx-3">
        <h6 class="mt-2 text-center text-dark"><i class="fa-solid fa-circle-xmark text-danger fs-5 mb-2"></i><br/>Tu pedido ya ha sido aceptado y no puedes modificarlo</h6>
      </div>
    </div>

    <!-- Kitchen Paused (418) -->
    <div v-if="showClosedKitchetError" class="position-fixed end-0 bg-white border shadow-lg p-3 rounded mb-3 mr-5 d-none d-md-flex align-items-center" style="z-index: 10000; bottom: 13%;">
      <h6 class="mt-2 text-dark"><i class="fa-solid fa-circle-xmark text-danger me-2"></i> ¡Estamos a tope!<br>La cocina está pausada un momento. En breve podrás hacer tu pedido.</h6>
    </div>
    <div v-if="showClosedKitchetError" class="position-fixed top-0 start-0 w-100 h-100 d-md-none d-flex align-items-center justify-content-center" style="background-color: rgba(0, 0, 0, 0.5); z-index: 10000;">
      <div class="bg-white border shadow-lg p-3 rounded w-100 mx-3">
        <h6 class="mt-2 text-center text-dark"><i class="fa-solid fa-circle-xmark text-danger fs-5 mb-2"></i><br/>¡Estamos a tope!<br>La cocina está pausada un momento. En breve podrás hacer tu pedido.</h6>
      </div>
    </div>

    <!-- Restaurant Closed (401) -->
    <div v-if="showRestaurantClosedError" class="position-fixed end-0 bg-white border shadow-lg p-3 rounded mb-3 mr-5 d-none d-md-flex align-items-center" style="z-index: 10000; bottom: 13%;">
      <h6 class="mt-2 text-dark"><i class="fa-solid fa-circle-xmark text-danger me-2"></i> El restaurante ha cerrado<br>Vuelva en otro momento para poder ser atendido</h6>
    </div>
    <div v-if="showRestaurantClosedError" class="position-fixed top-0 start-0 w-100 h-100 d-md-none d-flex align-items-center justify-content-center" style="background-color: rgba(0, 0, 0, 0.5); z-index: 10000;">
      <div class="bg-white border shadow-lg p-3 rounded w-100 mx-3">
        <h6 class="mt-2 text-center text-dark"><i class="fa-solid fa-circle-xmark text-danger fs-5 mb-2"></i><br/>El restaurante ha cerrado<br>Vuelva en otro momento para poder ser atendido</h6>
      </div>
    </div>

    <!-- Custom Order Error -->
    <div v-if="showError && errorMessage" class="position-fixed end-0 bg-white border shadow-lg p-3 rounded mb-3 mr-5 d-none d-md-flex align-items-center" style="z-index: 10000; bottom: 13%;">
      <h6 class="mt-2 text-dark"><i class="fa-solid fa-circle-xmark text-danger me-2"></i> {{ errorMessage }}</h6>
    </div>
    <div v-if="showError && errorMessage" class="position-fixed top-0 start-0 w-100 h-100 d-md-none d-flex align-items-center justify-content-center" style="background-color: rgba(0, 0, 0, 0.5); z-index: 10000;">
      <div class="bg-white border shadow-lg p-3 rounded w-100 mx-3">
        <h6 class="mt-2 text-center text-dark"><i class="fa-solid fa-circle-xmark text-danger fs-5 mb-2"></i><br/>{{ errorMessage }}</h6>
      </div>
    </div>

    <!-- General Error -->
    <div v-if="showError && !errorMessage" class="position-fixed end-0 bg-white border shadow-lg p-3 rounded mb-3 mr-5 d-none d-md-flex align-items-center" style="z-index: 10000; bottom: 13%;">
      <h6 class="mt-2 text-dark"><i class="fa-solid fa-circle-xmark text-danger me-2"></i> ¡Ha ocurrido un error!<br>Consulte con el restaurante para más información.</h6>
    </div>
    <div v-if="showError && !errorMessage" class="position-fixed top-0 start-0 w-100 h-100 d-md-none d-flex align-items-center justify-content-center" style="background-color: rgba(0, 0, 0, 0.5); z-index: 10000;">
      <div class="bg-white border shadow-lg p-3 rounded w-100 mx-3">
        <h6 class="mt-2 text-center text-dark"><i class="fa-solid fa-circle-xmark text-danger fs-5 mb-2"></i><br/>¡Ha ocurrido un error!<br>Consulte con el restaurante para más información.</h6>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderAlerts',
  props: {
    showPlateMaxError: { type: Boolean, default: false },
    showDeliveryError: { type: Boolean, default: false },
    showClosedKitchetError: { type: Boolean, default: false },
    showRestaurantClosedError: { type: Boolean, default: false },
    showError: { type: Boolean, default: false },
    errorMessage: { type: String, default: '' }
  }
}
</script>

<style scoped>
.order-alerts-container {
  pointer-events: none; /* Let clicks pass through if no alerts are shown */
}
.order-alerts-container > div {
  pointer-events: all; /* Allow clicks on the alerts themselves if needed */
}
</style>
